<template>
    <div class="products_listing">
        <!-- <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading> -->
        <CommonHead></CommonHead>
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
            <div class="mainproduct_listing">
			<h1 class="desktop-hide">All Fabrics</h1>
                <SKLoader
                :repeat="1"
                :loading="isFilterLoading"
                speed="1s"
                >
                <SKProductFilter/>
                </SKLoader>
                <div class="filterbar" v-if="isFilterLoading === false">
					<a @click="togglefilter" class="filtershow" href="#">Filter<b-img class="plusfil" src="/shop/images/add.svg" alt="add"></b-img><b-img class="minusfil" src="/shop/images/minus.svg" alt="minus"></b-img></a>
					<div class="allfilter">
						<h6>QUICK SEARCH BY</h6>
						<div class="bookfilter">
							<h4>Collections</h4>
                            <select-2 url="/shop/api/product-books/fabric" v-model="form.booksdrop"  @input="selectCollections()">
                            </select-2>
						</div>
						<div class="patternfilter">
							<h4>Patterns</h4>
                            <select-2 url="/shop/api/product-patterns/fabric" v-model="form.patternsdrop" @input="loadPColors()">
                            </select-2>
						</div>
						<div class="patterndesignfilter">
							<h4>Pattern Colors</h4>
                            <select-2 :url="patternColorDropdownUrl" v-model="form.colorsdrop"  @input="selectColors()" ref="formColorsdrop">
                            </select-2>
						</div>
						<div class="filter_by">
							<h6>Filter By</h6>
							<ul>
								<li><a href="javascript:;" v-b-toggle.collapse-brand>Brand <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-brand" accordion="my-accordion">
									<ul>
										<li v-for="(lb,lbk) in loadBrands" :key="lbk"><md-checkbox :value="lb.NAME" v-model="form.brands" @change="loadFilter(form)">{{lb.NAME}}</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-type>Type <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-type" accordion="my-accordion">
									<ul>
										<li v-for="(lt,ltk) in loadTypes" :key="ltk"><md-checkbox :value="lt.WEBTYPEVALUE" v-model="form.types" @change="loadFilter(form)">{{lt.WEBTYPEVALUE}}</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-color>Color <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-color" accordion="my-accordion">
									<ul>
										<li v-for="(lc,lck) in loadColors" :key="lck"><md-checkbox :value="lc.Colors" v-model="form.colors" @change="loadFilter(form)">{{lc.Colors}}</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-design>Pattern Design <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-design" accordion="my-accordion">
									<ul>
										<li v-for="(lp,lpk) in loadPatterns" :key="lpk"><md-checkbox :value="lp.WEBCATEGORYVALUE" v-model="form.patterns" @change="loadFilter(form)">{{lp.WEBCATEGORYVALUE}}</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-scale>Scale <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-scale" accordion="my-accordion">
									<ul>
										<li v-for="(lsc,lsck) in loadScale" :key="lsck"><md-checkbox :value="lsc.UPHOLSTERYRATINGCODE" v-model="form.scale" @change="loadFilter(form)">{{lsc.UPHOLSTERYRATINGCODE}}</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-use>Use <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-use" accordion="my-accordion">
									<ul>
										<li v-for="(lu,luk) in loadUses" :key="luk"><md-checkbox :value="lu.WEBUSEVALUE" v-model="form.use" @change="loadFilter(form)">{{lu.WEBUSEVALUE}}</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-abresults>Abrasion Results <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-abresults" accordion="my-accordion">
									<ul>
										<li>
											<h4>Wyzenbeek</h4>
											<md-radio v-model="radabresults" value="Wyzenbeek < 10000" @change="loadRadioFilter('abresults')">&lt; 10000</md-radio>
										</li>
										<li>
											<md-radio v-model="radabresults" value="Wyzenbeek 15000-30000" @change="loadRadioFilter('abresults')">15,000-30,000</md-radio>
										</li>
										<li>
											<md-radio v-model="radabresults" value="Wyzenbeek 30000+" @change="loadRadioFilter('abresults')">30,000+</md-radio>
										</li>
										<li>
											<h4>Martindale</h4>
											<md-radio v-model="radabresults" value="Martindale < 10000" @change="loadRadioFilter('abresults')">&lt; 10000</md-radio>
										</li>
										<li>
											<md-radio v-model="radabresults" value="Martindale 10000-15000" @change="loadRadioFilter('abresults')">10,000-15,000</md-radio>
										</li>
										<li>
											<md-radio v-model="radabresults" value="Martindale 15000-30000" @change="loadRadioFilter('abresults')">15,000-30,000</md-radio>
										</li>
										<li>
											<md-radio v-model="radabresults" value="Martindale 30000+" @change="loadRadioFilter('abresults')">30,000+</md-radio>
										</li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-passes>Test Results & Certifications <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-passes" accordion="my-accordion">
									<ul>
										<li v-for="(lps,lpsk) in loadPasses" :key="lpsk"><md-checkbox :value="lps.FIRETESTSCODE" v-model="form.passes" @change="loadFilter(form)">{{lps.FIRETESTSCODE}}</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-performance>Performance <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-performance" accordion="my-accordion">
									<ul>
										<li v-for="(lpers,lpersk) in loadPerformance" :key="lpersk">
											<md-radio v-model="radperformance" :value="lpers.SUNTAFGENDERVALUE" @change="loadRadioFilter('performance')">{{lpers.SUNTAFGENDERVALUE}}</md-radio>
										</li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-fibercontent>Fiber Content <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-fibercontent" accordion="my-accordion">
									<ul>
										<li v-for="(lfc,lfck) in loadFibercontent" :key="lfck"><md-checkbox :value="lfc.FIBERCONTENT" v-model="form.fibercontent" @change="loadFilter(form)">{{lfc.FIBERCONTENT}}</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
                                <li><a href="javascript:;" v-b-toggle.collapse-panelprogram>Panel Program <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-panelprogram" accordion="my-accordion">
									<ul>
										<li><md-checkbox value="Panel Program" v-model="form.panelprogram" @change="loadFilter(form)">Panel Program</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-colorworks>Colorworks <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-colorworks" accordion="my-accordion">
									<ul>
										<li><md-checkbox value="colorworks" v-model="form.colorworks" @change="loadFilter(form)">Colorworks</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-exclusive>Exclusive <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-exclusive" accordion="my-accordion">
									<ul>
										<li><md-checkbox value="exclusive" v-model="form.exclusive" @change="loadFilter(form)">Exclusive</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-madeinusa>Made in USA <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-madeinusa" accordion="my-accordion">
									<ul>
										<li><md-checkbox value="USA" v-model="form.madeinusa" @change="loadFilter(form)">Made in USA</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-status>Status <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-status" accordion="my-accordion">
									<ul>
										<li v-for="(ls,lsk) in loadStatus" :key="lsk"><md-checkbox :value="ls.PA" v-model="form.status" @change="loadFilter(form)">{{ls.PA}}</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
								<li><a href="javascript:;" v-b-toggle.collapse-showroom>Showroom <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-showroom" accordion="my-accordion">
									<ul>
										<li><md-checkbox value="showroom" v-model="form.showroom" @change="loadFilter(form)">Display showroom items</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
                                <li><a href="javascript:;" v-b-toggle.collapse-sale>Sale <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-sale" accordion="my-accordion">
									<ul>
										<li><md-checkbox value="Sale" v-model="form.sale" @change="loadFilter(form)">Sale</md-checkbox></li>
									</ul>
								</b-collapse>
								</li>
                                <li><a href="javascript:;" v-b-toggle.collapse-price>Price / Yd <b-img class="addicon" src="/shop/images/add.svg" fluid alt="add image"></b-img><b-img class="minusicon" src="/shop/images/minus.svg" fluid alt="minusimage"></b-img></a>
								<b-collapse id="collapse-price" accordion="my-accordion">
									<ul>
										<li><RangeSlider v-model="form.price" :min="minprice" :max="maxprice" :format="format" @update="loadFilter(form)" /></li>
									</ul>
								</b-collapse>
								</li>
							</ul>
						</div>
						<div class="mobile-category">
						<h4>Category</h4>
							<ul>
								<li><router-link to="/shop/products/fabric" :class="[selectedPage.includes('fabric') ? activeClass : '']">Fabrics</router-link></li>
								<li><router-link to="/shop/products/trim" :class="[selectedPage.includes('trim') ? activeClass : '']">Trimming</router-link></li>
								<!-- <li><router-link to="/shop/products/hardware" :class="[selectedPage.includes('hardware') ? activeClass : '']">Hardware</router-link></li> -->
								<li><a href="/hardware-brands/">Hardware</a></li>
								<li><router-link to="/shop/products/sample" :class="[selectedPage.includes('sample') ? activeClass : '']">Sample</router-link></li>
							</ul>
						</div>
					</div>
					</div>
					<div class="productsbar">
						<div class="topsection">
							<h1>All Fabrics</h1>
							<div class="sortby">
								<label class="sort">Sort By: </label>
								<v-select
								:options="sorting"
								v-model="form.sort"
								@input="loadFilter"
								:reduce="sorting => sorting.value"
								label="text"
								:clearable="false"
								:searchable="false"
								placeholder="Sorting"
							></v-select>
							</div>
                    </div>
                    <div class="productselectedfilter" v-if="(form.brands.length > 0)||(form.types.length > 0)||(form.patterns.length > 0)||(form.colors.length > 0)||(form.scale.length > 0)||(form.use.length > 0)||(form.status.length > 0)||(form.passes.length > 0)||(form.performance.length > 0)||(form.abresults.length > 0)||(form.fibercontent.length > 0)||(form.colorworks.length > 0)||(form.exclusive.length > 0)||(form.madeinusa.length > 0)||(form.panelprogram.length > 0)||(form.showroom.length > 0)||(form.sale.length > 0)">
                        <b-form-tags v-if="form.brands.length > 0" v-model="form.brands" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.brands"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
						<b-form-tags v-if="form.types.length > 0" v-model="form.types" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.types"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
						<b-form-tags v-if="form.patterns.length > 0" v-model="form.patterns" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.patterns"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.colors.length > 0" v-model="form.colors" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.colors"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.scale.length > 0" v-model="form.scale" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.scale"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
						<b-form-tags v-if="form.use.length > 0" v-model="form.use" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.use"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.abresults.length > 0" v-model="form.abresults" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.abresults"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
						<b-form-tags v-if="form.status.length > 0" v-model="form.status" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.status"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
						<b-form-tags v-if="form.passes.length > 0" v-model="form.passes" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.passes"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.performance.length > 0" v-model="form.performance" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.performance"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.fibercontent.length > 0" v-model="form.fibercontent" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.fibercontent"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.panelprogram.length > 0" v-model="form.panelprogram" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.panelprogram"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.colorworks.length > 0" v-model="form.colorworks" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.colorworks"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.exclusive.length > 0" v-model="form.exclusive" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.exclusive"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.madeinusa.length > 0" v-model="form.madeinusa" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.madeinusa"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
						<b-form-tags v-if="form.showroom.length > 0" v-model="form.showroom" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.showroom"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <b-form-tags v-if="form.sale.length > 0" v-model="form.sale" no-outer-focus class="mb-2">
                            <template v-slot="{removeTag }">
                                <ul class="list-tag">
                                <b-card
                                    v-for="tag in form.sale"
                                    :key="tag"
                                    :id="`tag_${tag.replace(/\s/g, '_')}_`"
                                    tag="li"
                                    class="mt-1 mr-1"
                                    body-class="py-1 pr-2 text-nowrap">
                                    <strong>{{ tag }}</strong>
                                    <b-button
                                    @click="removeTag(tag);refreshTag(tag)"
                                    variant="link"
                                    size="sm"
                                    :aria-controls="`tag_${tag.replace(/\s/g, '_')}_`"
                                    ><b-img class="closefilter" src="/shop/images/close.svg" fluid alt="close image"></b-img></b-button>
                                </b-card>
                                </ul>
                            </template>
                        </b-form-tags>
                        <a class="clearfilter" href="javascript:;" @click="resetFilter">Clear all</a>
                    </div>
                    <div class="mainproducts">
                        <SKLoader :repeat="4*3" :loading="isLoading">
                        <SKProductCard/>
                        </SKLoader>
                        <p v-if="rows == 0">No results found.</p>
                        <div class="productbox" v-for="(lp,lpk) in loadProducts" :key="lpk">
                            <a :href="'/shop/product/'+lp.ITEMID+'/'+lp.DETAIL[0].INVENTCOLORID" class="imgbox" :target="hrefTarget(lp.ITEMID,lp.DETAIL[0].INVENTCOLORID)">
                                <b-img class="proimg" :src="lp.DETAIL[0].MEDIUM_IMAGE" fluid alt="product1 image"></b-img>
                                <b-img class="cw-overlay" v-if="lp.COLORWORKS == 1" src="/shop/images/cw-overlay.png"></b-img>
                                <span v-if="lp.DIFFDAYS <= 365" class="newtag">New</span>
                                <span v-if="(lp.DETAIL[0].ABCCODEVALUE != 'A' && lp.DETAIL[0].ABCCODEVALUE != 'B' && lp.DETAIL[0].ABCCODEVALUE != 'C' && lp.DETAIL[0].ABCCODEVALUE != 'D' && lp.DETAIL[0].ABCCODEVALUE != 'E' && lp.DETAIL[0].ABCCODEVALUE != 'F' && lp.DETAIL[0].ABCCODEVALUE != 'X' && lp.DETAIL[0].ABCCODEVALUE != 'L')" class="saletag">Sale</span>
                            </a>
                            <div class="contentbox">
                                <div class="smallimages" v-if="lp.DETAIL.length > 0">
                                    <a v-for="(sw,swind) in lp.DETAIL" :key="swind" :href="sw.LINK" class="forborder" v-if="sw.INVENTCOLORID != '99'" @mouseover="loadswatchdata(sw,lp.ITEMID,sw.INVENTCOLORID,$event)" :target="hrefTarget(lp.ITEMID,sw.INVENTCOLORID)">
                                        <b-img class="smallimg" :src="sw.SMALL_IMAGE" fluid alt="product1 image"></b-img>
                                    </a>
                                    <a :href="'/shop/product/'+lp.ITEMID+'/'+lp.DETAIL[0].INVENTCOLORID" class="forborder" v-if="lp.TOTALSWATCH > 5"><div class="moreprod">+{{lp.TOTALSWATCH - 5}}</div></a>
                                </div>
                                <h4><a :href="'/shop/product/'+lp.ITEMID+'/'+lp.DETAIL[0].INVENTCOLORID" :target="hrefTarget(lp.ITEMID,lp.DETAIL[0].INVENTCOLORID)">{{lp.ITEMNAME}} / <span class="clname">{{lp.DETAIL[0].COLORNAME}}</span></a></h4>
                                <p v-if="lp.DETAIL[0].SHORTDESCRIPTION != ''">{{lp.DETAIL[0].SHORTDESCRIPTION}}</p>
                                <div v-if="lp.DETAIL[0].DISCOUNTPRICE > 0 && user.id > 0"><p class="regprice">${{lp.DETAIL[0].PRICE}}</p><span class="saleprice">${{lp.DETAIL[0].DISCOUNTPRICE}}/yd.</span></div>
                                <p v-else-if="(user.id > 0 && lp.DETAIL[0].DISCOUNTPRICE == 0) && lp.DETAIL[0].COLORWORKS != '1'">${{lp.DETAIL[0].PRICE}}/yd.</p>
                            </div>
                        </div>
                    </div>
                    <div class="propagination" v-if="loadProducts.length>0">
                        <div class="mt-3 custompage">
                            <b-pagination
                                v-model="currentPage"
                                @input="paginationChange"
                                :total-rows="rows"
                                :per-page="perPage"
                                align="center"
                                first-number
                                last-number
                            ></b-pagination>
                        </div>
                        <div class="itemspage">
                            <label class="pageitem">Items per page :</label>
                            <v-select
                                :options="itemspage"
                                v-model="form.items"
                                @input="loadFilter"
                                :clearable="false"
                                :searchable="false"
                                placeholder="40"
                            ></v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CommonFoot></CommonFoot>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import SKProductCard from "@/views/skeletons/SKProductCard";
import SKProductFilter from "@/views/skeletons/SKProductFilter";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Select2 from './Select2.vue';
import RangeSlider from '@vueform/slider/dist/slider.vue2';
import '@vueform/slider/themes/default.css';

export default {
  components: {
    CommonHead,
    CommonFoot,
    SKProductCard,
    SKProductFilter,
    'v-select': vSelect,
    Loading,
    Select2,
    RangeSlider
  },
  metaInfo: {
    title: 'RM COCO | View All Fabrics',
    meta: [{
        name: 'description',
        content: 'Fine linens, silks, jaquards, chenilles, prints, velvets, sheers, and more! Over one million yards of wholesale fabric in stock.'
    }],
  },
  computed:{
        ...mapGetters(["user"]),
        selectedPage(){
            return this.$route.path;
        }
  },
  mounted(){
        this.isLoading = true;
        this.isFilterLoading = true;
        this.PageloadFilter();
        this.$store.dispatch("loadBooksdrop","fabric").then(loadBooksdrop => {
            this.loadBooksdrop = loadBooksdrop.data;
        });
        this.$store.dispatch("loadPatternsdrop","fabric").then(loadPatternsdrop => {
            this.loadPatternsdrop = loadPatternsdrop.data;
            this.loadPatternsdropNew = this.loadPatternsdrop.slice(0, this.limit);
        });
        this.$store.dispatch("loadColorsdrop","fabric").then(loadColorsdrop => {
            this.loadColorsdrop = loadColorsdrop.data.items;
        });
        this.observer = new IntersectionObserver(this.infiniteScroll);
        if(this.$route.query.designcolor){
            this.form.colorsdrop = this.$route.query.designcolor;
        }
  },
  data(){
      return{
		isHidden: false,
        activeClass:'active',
        loadProducts:[],
        loadBrands:{},
        loadTypes:{},
        loadColors:{},
        loadPatterns:{},
        loadScale:{},
        loadUses:{},
        loadPasses:{},
        loadPerformance:{},
        loadStatus:{},
        loadabcounts:{
            cnt_wyzen_10k: 0,
            cnt_wyzen_15kt30k: 0,
            cnt_wyzen_30kplus: 0,
            cnt_mardin_10k: 0,
            cnt_mardin_10kt15k: 0,
            cnt_mardin_15kt30k: 0,
            cnt_mardin_30kplus: 0
        },
        loadBooksdrop: [],
        loadPatternsdrop: [],
        loadFibercontent:{},
        loadColorsdrop: [],
        loadColorworkscount:{
            cnt_colorworks:0
        },
        loadExclusivecount:{
            cnt_exclusive:0
        },
        loadmadeinusacount:{
            cnt_madeinusa:0
        },
        sritem:{
            cnt_showroom:0
        },
        rows: 40,
        perPage: 40,
        currentPage: 1,
        sorting: [
          { value: 'newest', text: 'Newest'},
          //{ value: 'abccode', text: 'Popularity'},
          { value: 'lowtohigh', text: 'Price: Low to High'},
          { value: 'hightolow', text: 'Price: High to Low'}
        ],
        itemspage: [
           '20','40','100'
        ],
        quantity: 1,
        radperformance:'',
        radabresults:'',
        form:{
            booksdrop:'',
            patternsdrop:'',
            colorsdrop:'',
            brands: [],
            types: [],
            colors: [],
            patterns: [],
            scale:[],
            use: [],
            abresults:[],
            passes: [],
            performance:[],
            status:[],
            showroom: [],
            fibercontent:[],
            panelprogram:[],
            colorworks: [],
            exclusive: [],
            madeinusa: [],
            sale: [],
            price:[1,400],
            items:40,
            sort:'newest',
            page:1
        },
        minprice: 0,
        maxprice: 200,
        format: function (value) {
          return `$${Math.round(value)}`
        },
        isLoading: false,
        isFilterLoading: true,
        breadcrumb: [
            {
                text: 'Home',
                href: '/'
            },
            {
                text: 'Fabric',
                active: true
            }
        ],
        observer: null,
        limit:10,
        search:'',
        hasNextPage:false,
        loadPatternsdropNew:[],
        patternColorDropdownUrl:'/shop/api/product-colors/fabric/all',
        oldBooksdrop: "",
      };
  },
  methods: {
		togglefilter(){
            $(".allfilter").toggle();
            $(".filtershow").toggleClass("minusshow");
		},
        paginationChange(page){
            this.form.page = page;
            this.loadFilter();
        },
        selectColors(){
            this.form.booksdrop = '';
            this.selectSelection();
        },
        selectCollections(){
            this.form.patternsdrop = '';
            this.form.colorsdrop = '';
            this.selectSelection();
        },
		loadPColors(){
            this.form.booksdrop = "";
            this.form.colorsdrop = "";
            if(this.form.patternsdrop != ''){
                this.patternColorDropdownUrl="/shop/api/product-colors/fabric/"+this.form.patternsdrop;
            }else{
                this.patternColorDropdownUrl="/shop/api/product-colors/fabric/all";
            }
            var type= this.form.patternsdrop !=''?this.form.patternsdrop:null;
            this.$store.dispatch("isShowRoomByItem",type).then(isShowRoomByItem => {
                if(isShowRoomByItem.data.length > 0 && isShowRoomByItem.data[0].hasOwnProperty('SHOWROOM') && isShowRoomByItem.data[0].SHOWROOM == 1){
                    this.form.showroom[0] = "showroom";
                } else{
                    this.form.showroom = [];
                }
                this.loadFilter();
            });
        },
        selectSelection(){
            this.form.showroom=[];
            if(this.form.booksdrop != null && this.form.booksdrop !=''){
                if (this.form.patternsdrop != '') {
                    this.oldBooksdrop = this.form.booksdrop;
                }
                let bdseleced =  this.loadBooksdrop.items.find(el => el.text == this.form.booksdrop);
                if(bdseleced != undefined){
                    if(bdseleced.showroom == "1"){
                        this.form.showroom=['showroom'];
                    }
                }
            }
            this.form.brands= [];
            this.form.types= [];
            this.form.colors= [];
            this.form.patterns= [];
            this.form.scale= [];
            this.form.use= [];
            this.form.passes= [];
            this.form.performance = [];
            this.form.status=[];
            this.form.abresults = [];
            this.form.fibercontent = [];
            this.form.panelprogram = [];
            this.form.colorworks=[];
            this.form.exclusive=[];
            this.form.madeinusa=[];
            this.form.sale=[];
            this.radperformance = '';
            this.radabresults = '';
            this.form.page=1;
            if(this.form.colorsdrop != ""){
                this.$store.dispatch("isShowRoomByColor",this.form.colorsdrop).then(isShowRoomByColor => {
                    if(isShowRoomByColor.data.length > 0 && isShowRoomByColor.data[0].hasOwnProperty('SHOWROOM') && isShowRoomByColor.data[0].SHOWROOM == 1){
                        this.form.showroom[0] = "showroom";
                    } else{
                        this.form.showroom = [];
                    }
                    this.loadFilter();
                });
            }else{
                this.loadFilter();
            }
        },
        filtersinfowithcount(queryString){
            const url = new URL(window.location.origin+"/?"+queryString);
            let paramMap = {}
            url.searchParams.forEach((value,key)=>paramMap[key]=value);
            const ignoreKey = ["items","sort","page"];
            let cacheKey = ("filter."+Object.keys(paramMap).filter(d=>(!ignoreKey.includes(d))).map(d=>`${d}${paramMap[d].replace(/\s+/g,"")}`).sort().join(".")).toUpperCase();
            let fromCache = this.getFromCache(cacheKey);
            if(fromCache.status){
                const loadfabricFilters = fromCache.data;
                this.loadBrands = loadfabricFilters.brands;
                this.loadTypes = loadfabricFilters.types;
                this.loadColors = loadfabricFilters.colors;
                this.loadPatterns = loadfabricFilters.patterns;
                this.loadScale = loadfabricFilters.scales;
                this.loadUses = loadfabricFilters.use;
                this.loadPasses = loadfabricFilters.passes;
                this.loadPerformance = loadfabricFilters.performance;
                this.loadabcounts = loadfabricFilters.abresults;
                this.loadFibercontent = loadfabricFilters.fibercont;
                this.loadColorworkscount = loadfabricFilters.colorworks;
                this.loadExclusivecount = loadfabricFilters.exclusive;
                this.loadmadeinusacount = loadfabricFilters.madeinusa;
                this.loadStatus = loadfabricFilters.status;
                this.sritem = loadfabricFilters.showroom;
                this.isFilterLoading = false;
            }
            this.$store.dispatch("loadfabricFilters",queryString).then(loadfabricFilters => {
                this.setToCache(cacheKey,loadfabricFilters);
                this.loadBrands = loadfabricFilters.brands;
                this.loadTypes = loadfabricFilters.types;
                this.loadColors = loadfabricFilters.colors;
                this.loadPatterns = loadfabricFilters.patterns;
                this.loadScale = loadfabricFilters.scales;
                this.loadUses = loadfabricFilters.use;
                this.loadPasses = loadfabricFilters.passes;
                this.loadPerformance = loadfabricFilters.performance;
                this.loadabcounts = loadfabricFilters.abresults;
                this.loadFibercontent = loadfabricFilters.fibercont;
                this.loadColorworkscount = loadfabricFilters.colorworks;
                this.loadExclusivecount = loadfabricFilters.exclusive;
                this.loadmadeinusacount = loadfabricFilters.madeinusa;
                this.loadStatus = loadfabricFilters.status;
                this.sritem = loadfabricFilters.showroom;
                this.isFilterLoading = false;
            });
        },
        loadRadioFilter(val){
            if(val == 'performance'){
                this.form.performance = [];
                this.form.performance = [this.radperformance];
            }
            if(val == 'abresults'){
                this.form.abresults = [];
                this.form.abresults = [this.radabresults];
            }
            this.loadFilter();
        },
        loadFilter(){
            this.isLoading = true;
            this.isFilterLoading = false;
            this.loadProducts = [];
            let url = [];
            if(this.form.booksdrop != ''){
                url["book"] = this.form.booksdrop;
            }
            if(this.form.patternsdrop != ''){
                url["design"] = this.form.patternsdrop;
            }
            if(this.form.colorsdrop != ''){
                url["designcolor"] = this.form.colorsdrop;
            }
            if(this.form.brands.length > 0){
                url["brand"] = this.form.brands.join();
            }
            if(this.form.types.length > 0){
                url["type"] = this.form.types.join();
            }
            if(this.form.scale.length > 0){
                url["scale"] = this.form.scale.join();
            }
            if(this.form.colors.length > 0){
                url["color"] = this.form.colors.join();
            }
            if(this.form.patterns.length > 0){
                url["pattern"] = this.form.patterns.join();
            }
            if(this.form.passes.length > 0){
                url["passes"] = this.form.passes.join();
            }
            if(this.form.abresults.length > 0){
                url["abresults"] = this.form.abresults;
            }
            if(this.form.performance.length > 0){
                url["performance"] = this.form.performance;
            }
            if(this.form.use.length > 0){
                url["use"] = this.form.use.join();
            }
			if(this.form.status.length > 0){
                url["status"] = this.form.status.join();
            }
			if(this.form.showroom.length > 0){
                url["showroom"] = this.form.showroom.join();
            }
            if(this.form.fibercontent.length > 0){
                url["fibercontent"] = this.form.fibercontent.join();
            }
            if(this.form.panelprogram.length > 0){
                url["panelprogram"] = this.form.panelprogram.join();
            }
            if(this.form.colorworks.length > 0){
                url["colorworks"] = this.form.colorworks.join();
            }
            if(this.form.exclusive.length > 0){
                url["exclusive"] = this.form.exclusive.join();
            }
            if(this.form.madeinusa.length > 0){
                url["madeinusa"] = this.form.madeinusa.join();
            }
            if(this.form.items != null){
                url["items"] = this.form.items;
            }
            if(this.form.sort != null){
                url["sort"] = this.form.sort;
            }
            if(this.form.sale.length > 0){
                url["sale"] = this.form.sale.join();
            }
            if(this.form.price.length > 0){
                url["price"] = this.form.price.join();
            }
            url["page"] = this.form.page;
            this.$router.push({query: url });

            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.$store.dispatch("loadfabricProducts",queryString).then(loadProducts => {
                this.rows = loadProducts.data.total;
                this.currentPage = this.form.page;
                this.perPage = this.form.items;
                this.loadProducts = loadProducts.data.products;
                this.isLoading = false;
            });
			this.AciveFilter();
        },
		PageloadFilter(){
            let url = [];
            if(this.$route.query.book){
                url["book"] = this.$route.query.book;
                if(this.$route.query.book.toLowerCase() == 'eclipse blackout'){
                    url["book"] = 'Eclipse Blackouts';
                }
            }
            if(this.$route.query.design){
                url["design"] = this.$route.query.design;
                this.patternColorDropdownUrl="/shop/api/product-colors/fabric/"+url["design"];
            }
            if(this.$route.query.designcolor){
                url["designcolor"] = this.$route.query.designcolor;
            }
            if(this.$route.query.brand){
				url["brand"] = this.$route.query.brand;
				this.$root.$emit('bv::toggle::collapse', 'collapse-brand');
			}
            if(this.$route.query.type){
				url["type"] = this.$route.query.type;
				this.$root.$emit('bv::toggle::collapse', 'collapse-type');
			}
            if(this.$route.query.color){
				url["color"] = this.$route.query.color;
				this.$root.$emit('bv::toggle::collapse', 'collapse-color');
			}
            if(this.$route.query.pattern){
				url["pattern"] = this.$route.query.pattern;
				this.$root.$emit('bv::toggle::collapse', 'collapse-design');
            }
            if(this.$route.query.scale){
				url["scale"] = this.$route.query.scale;
				this.$root.$emit('bv::toggle::collapse', 'collapse-scale');
			}
            if(this.$route.query.passes){
				url["passes"] = this.$route.query.passes;
				this.$root.$emit('bv::toggle::collapse', 'collapse-passes');
            }
            if(this.$route.query.abresults){
				this.abresults = this.$route.query.abresults;
				url["abresults"] = this.$route.query.abresults;
				this.$root.$emit('bv::toggle::collapse', 'collapse-abresults');
            }
            if(this.$route.query.performance){
                this.performance = this.$route.query.performance;
				url["performance"] = this.$route.query.performance;
				this.$root.$emit('bv::toggle::collapse', 'collapse-performance');
			}
            if(this.$route.query.use){
				url["use"] = this.$route.query.use;
				this.$root.$emit('bv::toggle::collapse', 'collapse-use');
			}
			if(this.$route.query.status){
				url["status"] = this.$route.query.status;
				this.$root.$emit('bv::toggle::collapse', 'collapse-status');
            }
            if(this.$route.query.fibercontent){
				url["fibercontent"] = this.$route.query.fibercontent;
				this.$root.$emit('bv::toggle::collapse', 'collapse-fibercontent');
            }
            if(this.$route.query.panelprogram){
				url["panelprogram"] = this.$route.query.panelprogram;
				this.$root.$emit('bv::toggle::collapse', 'collapse-panelprogram');
            }
            if(this.$route.query.colorworks){
				url["colorworks"] = this.$route.query.colorworks;
				this.$root.$emit('bv::toggle::collapse', 'collapse-colorworks');
            }
            if(this.$route.query.exclusive){
				url["exclusive"] = this.$route.query.exclusive;
				this.$root.$emit('bv::toggle::collapse', 'collapse-exclusive');
            }
            if(this.$route.query.madeinusa){
				url["madeinusa"] = this.$route.query.madeinusa;
				this.$root.$emit('bv::toggle::collapse', 'collapse-madeinusa');
			}
			if(this.$route.query.showroom){
				url["showroom"] = this.$route.query.showroom;
            }
            if(this.$route.query.sale){
				url["sale"] = this.$route.query.sale;
            }
            if(this.$route.query.items){
                url["items"] = this.$route.query.items;
            }else{
                url["items"] = this.form.items;
            }
            if(this.$route.query.sort){
                url["sort"] = this.$route.query.sort;
            }else{
                url["sort"] = this.form.sort;
            }
            if(this.$route.query.page){
                url["page"] = this.$route.query.page;
                this.form.page = this.$route.query.page;
            }else{
                url["page"] = this.form.page;
            }
            if(this.$route.query.price){
                url["price"] = this.$route.query.price;
            }
            this.$router.push({query: url });

            var queryString = Object.keys(url).map((key) => {
                return encodeURIComponent(key) + '=' + encodeURIComponent(url[key])
            }).join('&');
            this.filtersinfowithcount(queryString);
            this.$store.dispatch("loadfabricProducts",queryString).then(loadProducts => {
                this.rows = loadProducts.data.total;
                this.minprice = loadProducts.data.minprice;
                this.maxprice = loadProducts.data.maxprice;
                if(this.$route.query.price){
                    this.form.price=this.$route.query.price.split(',');
                }else{
                    this.form.price=[loadProducts.data.minprice,loadProducts.data.maxprice];
                }
                this.currentPage = this.form.page;
                this.perPage = this.form.items;
                this.loadProducts = loadProducts.data.products;
                this.isLoading = false;
            });
			this.AciveFilter();
        },
		AciveFilter(){
            if(this.$route.query.book){
				this.form.booksdrop=this.$route.query.book;
            }
            if(this.$route.query.design){
				this.form.patternsdrop=this.$route.query.design;
            }
            if(this.$route.query.designcolor){
				this.form.colorsdrop=this.$route.query.designcolor;
			}
            if(this.$route.query.brand){
				this.form.brands=this.$route.query.brand.split(',');
			}
			if(this.$route.query.type){
				this.form.types=this.$route.query.type.split(',');
			}
			if(this.$route.query.color){
				this.form.colors=this.$route.query.color.split(',');
			}
			if(this.$route.query.pattern){
				this.form.patterns=this.$route.query.pattern.split(',');
            }
            if(this.$route.query.scale){
				this.form.scale=this.$route.query.scale.split(',');
			}
			if(this.$route.query.passes){
				this.form.passes=this.$route.query.passes.split(',');
            }
            if(this.$route.query.performance){
                this.radperformance = this.$route.query.performance.toString();
				this.form.performance = [this.radperformance];
			}
			if(this.$route.query.use){
				this.form.use=this.$route.query.use.split(',');
			}
			if(this.$route.query.status){
				this.form.status=this.$route.query.status.split(',');
			}
			if(this.$route.query.showroom){
				this.form.showroom=this.$route.query.showroom.split(',');
            }
            if(this.$route.query.abresults){
                this.radabresults = this.$route.query.abresults.toString();
				this.form.abresults = [this.radabresults];
			}
            if(this.$route.query.fibercontent){
				this.form.fibercontent=this.$route.query.fibercontent.split(',');
            }
            if(this.$route.query.panelprogram){
				this.form.panelprogram=this.$route.query.panelprogram.split(',');
            }
            if(this.$route.query.colorworks){
				this.form.colorworks=this.$route.query.colorworks.split(',');
            }
            if(this.$route.query.exclusive){
				this.form.exclusive=this.$route.query.exclusive.split(',');
            }
            if(this.$route.query.madeinusa){
				this.form.madeinusa=this.$route.query.madeinusa.split(',');
            }
            if(this.$route.query.items){
			    this.form.items=this.$route.query.items;
			}
            if(this.$route.query.sort){
			    this.form.sort=this.$route.query.sort;
			}
            if(this.$route.query.sale){
				this.form.sale=this.$route.query.sale.split(',');
            }
            if(this.$route.query.price){
				this.form.price=this.$route.query.price.split(',');
            }
        },
        refreshTag(tag){
            if(this.form.performance.length < 1){
                this.radperformance = '';
            }
            if(this.form.abresults.length < 1){
                this.radabresults = '';
            }
            this.form.price = [1,400];
            setTimeout(function () { this.loadFilter() }.bind(this), 500);
        },
        resetFilter(){
            this.form.booksdrop = '';
            this.form.patternsdrop='';
            this.form.colorsdrop='';
            this.form.brands= [];
            this.form.types= [];
            this.form.colors= [];
            this.form.patterns= [];
            this.form.scale= [];
            this.form.use= [];
            this.form.passes= [];
            this.form.performance = [];
            this.form.abresults = [];
            this.form.fibercontent = [];
            this.form.panelprogram = [];
            this.form.status=[];
            this.form.showroom=[];
            this.form.colorworks=[];
            this.form.madeinusa=[];
            this.form.exclusive=[];
            this.form.sale=[];
            this.form.price = [1,400];
            this.form.items=40;
            this.form.sort='newest';
            this.form.page=1;
            this.radperformance = '';
            this.radabresults = '';
            this.loadFilter();
        },
        loadswatchdata(detail,itemid,inventcolorid,event){
            $(".productbox .imgbox").removeClass("active");
            $(event.target).parents(".productbox").children(".imgbox").addClass("active");
            let buildurl = $(event.target).attr("href");
            let hoverimg = detail.MEDIUM_IMAGE;
            let colornamehvr = detail.COLORNAME;
            $(event.target).parents(".productbox").children(".imgbox").attr("href",buildurl);
            $(event.target).parents(".productbox").children(".imgbox").children(".proimg").attr("src",hoverimg);
            $(event.target).parents(".contentbox").children("h4").children("a").attr("href",buildurl);
            $(event.target).parents(".contentbox").children("h4").children("a").children(".clname").text(colornamehvr);
            let targetdata = this.hrefTarget(itemid,inventcolorid);
            $(event.target).parents(".productbox").children(".imgbox").attr("target",targetdata);
            $(event.target).parents(".contentbox").children("h4").children("a").attr("target",targetdata);            
        },
        async infiniteScroll ([{isIntersecting, target}]) {
            if (isIntersecting) {
                const ul = target.offsetParent;
                const scrollTop = target.offsetParent.scrollTop;
                this.limit += 10;
                this.loadPatternsdropNew = this.loadPatternsdrop.slice(0, this.limit);
                await this.$nextTick();
                ul.scrollTop = scrollTop;
            }
        },
        async onOpen () {
            let vm=this;
            vm.hasNextPage = vm.loadPatternsdrop.filter(pattern => pattern.includes(vm.search)).length > vm.loadPatternsdropNew.filter(pattern => pattern.includes(vm.search)).slice(0, vm.limit).length;
            if (vm.hasNextPage) {
                await vm.$nextTick();
                vm.observer.observe(vm.$refs.load)
            }
        },
        onClose () {
          this.observer.disconnect();
        },
        searchFun(s){
            if(s.length > 0){
                axios.get(`/shop/api/product-patterns/fabric/`+s).then(response => {
                    this.loadPatternsdrop= response.data;
                    this.loadPatternsdropNew = response.data;
                });
            }else{
                this.$store.dispatch("loadPatternsdrop","fabric").then(loadPatternsdrop => {
                    this.loadPatternsdrop = loadPatternsdrop.data;
                    this.loadPatternsdropNew = this.loadPatternsdrop.slice(0, this.limit);
                    return;
                });
            }
        },
        getPatternColorUrl(){
            if(this.form.patternsdrop){
                return "/shop/api/product-colors/fabric/"+this.form.patternsdrop;
            }else{
                return "/shop/api/product-colors/fabric/all";
            }
        },
        hrefTarget(itemid, inventcolorid){
            var itemid = itemid;
            var inventcolorid = inventcolorid;
            var isCustomizer = "";
            if(itemid == 'CW100' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW101' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW104' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW105' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW106' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW109' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW110' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW111' && inventcolorid == '99'){
                isCustomizer = "1";
            }else if(itemid == 'CW113' && inventcolorid == '99'){
                isCustomizer = "1";
            }
            if(isCustomizer == ""){
                return "_self";
            }else{
                return "_blank";
            }
        },
    }
};
</script>
<style>
.breadcrumb{
    background: #fff;
    padding: 0;
    margin-top: 20px;
    margin-bottom: 0;
}
.breadcrumb li a{
    color:#303030;
    font-size: 12px;
}
.breadcrumb li a:hover{
    text-shadow: 0px 0px 1px #303030;
}
.breadcrumb li.active span{
    color: #777777;
    font-size: 12px;
}
.mainproduct_listing{
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
}
h1.desktop-hide{
	display:none;
}
.filtershow{
	display:none;
}
.filterbar{
    width: 16.5%;
    max-width: 230px;
    padding-bottom: 50px;
    padding-top: 20px;
}
.filterbar h6{
    text-align: left;
    font-weight: 600;
    margin-top: 20px;
    margin-bottom: 20px;
    text-transform: uppercase;
}
.filterbar h4{
    font-weight: 500;
    text-align: left;
    margin-top: 14px;
    margin-bottom: 20px;
}
.filterbar .bookfilter,.filterbar .patternfilter,.filterbar .patterndesignfilter{
    padding-bottom: 20px;
}
.filterbar .patterndesignfilter{
    border-bottom: 0;
}
.filterbar h4{
    margin-bottom: 10px;
}
.filterbar .ui.selection.dropdown{
    border: 1px solid #d2d2d2;
    border-radius: 3px;
    position: relative;
    -webkit-transition: inherit;
    transition: inherit;
    box-shadow: none;
}
.filterbar .ui.selection.dropdown::after,.sortby .ui.selection.dropdown::after{
    content: "";
    background: url(/shop/images/arrow.svg) no-repeat center;
    height: 10px;
    width:10px;
    position: absolute;
    right: 12px;
    top:13px;
    margin: 0;
}
.filterbar .ui.selection.dropdown.active::after,.sortby .ui.selection.dropdown.active::after{
    transform: rotate(180deg);
}
.filterbar .ui.selection.dropdown:hover,.sortby .ui.selection.dropdown:hover{
    border: 1px solid #d2d2d2;
}
.filterbar .ui.fluid.dropdown>.dropdown.icon,.sortby .ui.fluid.dropdown>.dropdown.icon{
    display:none;
}
.filterbar .ui.search.dropdown>input.search,.filterbar .ui.search.dropdown>.text{
    color: #303030 !important;
    font-size: 12px;
}
.filterbar .ui.selection.active.dropdown:hover,.filterbar .ui.selection.active.dropdown:hover .menu,.sortby .ui.selection.active.dropdown:hover,.sortby .ui.selection.active.dropdown:hover .menu{
    border-color: #d2d2d2;
    box-shadow: none;
}
.filterbar .ui.search.selection.dropdown>input.search,.filterbar .ui.search.selection.dropdown>span.sizer{
    line-height: 1.8em;
}
.filterbar .ui.selection.dropdown .menu,.productsbar .topsection .sortby .ui.selection.dropdown .menu{
    top: 45px;
    border-top: 1px solid #d2d2d2 !important;
    border-radius: 3px;
    box-shadow: none;
    outline: none;
}
.filterbar .ui.selection.dropdown .menu>.item{
    font-size: 12px;
    line-height: 20px;
    color: #303030;
    padding:0;
    border:0;
}
.productsbar .topsection .sortby .ui.selection.dropdown .menu .ui.selection.dropdown .menu>.item{
    font-size: 14px;
    line-height: 20px;
    color: #777777;
}
.filterbar .ui.selection.dropdown .menu>.item:hover,.filterbar .ui.selection.dropdown .menu>.item.selected,.productsbar .topsection .sortby .ui.selection.dropdown .menu>.item:hover,.productsbar .topsection .sortby .ui.selection.dropdown .menu>.item.selected{
    background: transparent;
}
.filterbar ul{
    padding-bottom: 10px;
    border-bottom: 1px solid #d2d2d2;
}
.filterbar ul li a{
    font-size: 12px;
    color: #303030;
    line-height: 24px;
    text-decoration: none;
    width: 100%;
}
.filterbar ul li a:hover{
    text-decoration: none;
}
.filterbar ul li a.active{
    font-weight: 600;
}
.filterbar .filter_by h6{
    margin-bottom: 0;
}
.filterbar .filter_by ul{
    border-bottom: 0;
}
.filterbar .filter_by ul li{
    border-bottom: 1px solid #d2d2d2;
    width: 100%;
}
.filterbar .filter_by ul li a{
    width: 100%;
    display: inline-block;
    height: 55px;
    line-height: 55px;
    font-size: 14px;
    color: #303030;
    font-weight: 500;
}
.filterbar .filter_by ul li a img.addicon,.filterbar .filter_by ul li a img.minusicon{
    height: 11px;
    width: 11px;
    float: right;
    margin-top: 22px;
}
.filterbar .filter_by ul li a img.minusicon{
    display: block;
}
.filterbar .filter_by ul li a.collapsed img.addicon{
    display: block;
}
.filterbar .filter_by ul li a img.addicon{
    display: none;
}
.filterbar .filter_by ul li a.collapsed img.minusicon{
    display: none;
}
.filterbar .filter_by ul li ul{
    width: 100%;
    border-bottom: 0;
}
.filterbar .filter_by ul li ul li{
    border-bottom: none;
    margin-bottom: 5px;
    font-size: 12px;
    color: #303030;
}
.filterbar .filter_by ul li ul li .md-checkbox,.filterbar .filter_by ul li ul li .md-radio{
	width:100%;
}
.filterbar .filter_by ul li ul li .md-checkbox .md-checkbox-label,
.filterbar .filter_by ul li ul li .md-radio .md-radio-label{
    line-height: 24px;
    padding-left: 10px;
    height: auto;
    display: inline-block;
	width:100%;
}
.filterbar .filter_by ul li ul li .md-radio{
	width:100%;
	margin-right:0;
}
.filterbar .filter_by ul li #collapse-color ul li .md-checkbox .md-checkbox-label{
    display: flex;
	justify-content: space-between;
}
.filterbar .filter_by ul li ul li span{
    height: 19px;
    width: 19px;
    display: inline-block;
    border-radius: 3px;
    margin-right: 10px;
}
.filterbar .filter_by ul li ul li .md-checkbox span,
.filterbar .filter_by ul li ul li .md-radio span{
	margin-right:0;
	float:right;
	width:auto;
	display:inherit;
}
.filterbar .slider-connect,.filterbar .slider-tooltip{
    background: #303030;
    border-color: #303030;
}
.emptycontent{display: none;}
.v-select{
    position: relative;
    width: 100%;
}
.vs--unsearchable .vs__dropdown-toggle{
	border: none;
    line-height: normal;
    position: relative;
    top: 3px;
    height: 38px;
}
.vs--searchable .vs__dropdown-toggle{
    height:38px;
    padding: 0;
    border:1px solid #d2d2d2;
    border-radius: 3px;
}
.vs__dropdown-menu{
    border:1px solid #d2d2d2;
    box-shadow: none;
    width: 100%;
    font-weight: normal;
}
.v-select .vs__actions::after{
    border: none;
    content: "";
    background: url(/shop/images/arrow.svg) no-repeat center;
    height: 10px;
    width:10px;
    position: absolute;
    right: 12px;
    top:14px;
    margin: 0;
}
.vs__actions .vs__open-indicator{
    display: none;
}
.v-select.vs--open .vs__actions::after{
    transform: rotate(180deg);
}
.vs--single .vs__selected{
    font-size: 12px;
    color: #303030;
}
.vs--single.vs--open .vs__selected{
    position: relative;
    opacity: 1;
}
.vs__dropdown-option{
    font-size: 12px;
    color:#303030;
    line-height: 30px;
    font-weight: normal;
}
.vs__dropdown-option--highlight {
	background: transparent;
	color: #303030;
}
.vs__search,
.vs__search:focus{
    font-size: 12px;
}
.productsbar .topsection .sortby{
    display: flex;
    justify-content: right;
    width: 21%;
    align-items: center;
}
.sortby .vs--searchable .vs__dropdown-toggle,.itemspage .vs--searchable .vs__dropdown-toggle{
    border:0;
}
.sortby .vs__selected,.itemspage .vs__selected{
    color:#303030;
    border: 0;
    font-size: 14px;
    font-weight: 500;
    margin:0;
    padding: 0;
}
.sortby .vs__dropdown-menu{
    min-width: 200px;
}
.vs__dropdown-menu li:hover{
    text-shadow: 0px 0px 1px #303030;
}
.itemspage .v-select{
    width:30%;
}
.itemspage .vs__dropdown-menu{
    min-width: 100px;
}
.itemspage .vs--single .vs__selected{
    line-height: 41px;
}
.productsbar .topsection .sortby .sort{
    font-size: 14px;
    color: #777777;
    float: left;
    width: 82px;
}
.productsbar{
    width: 80.5%;
}
.productsbar .topsection{
    width: 100%;
    border-bottom: 1px solid #d2d2d2;
    display: inline-block;
    padding-bottom: 5px;
}
.productsbar h1,.page--productstrim .productsbar h2,.page--productssample .productsbar h2{
    text-align: left;
    float: left;
    width: 79%;
	font-family: "Playfair Display", serif;
    line-height: 32px;
    font-size: 30px !important;
}
.productsbar h1.seo-purpose{
	display:none;
}
.productsbar .topsection .sortby form{
    float: left;
}
.mainproducts{
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    margin: 20px 0 70px 0;
    padding: 0;
}
.productselectedfilter{
    width:100%;
    display: inline-block;
    padding: 25px 0;;
}
.productselectedfilter .clearfilter{
    font-size: 12px;
    color: #303030;
    font-weight: normal;
    margin-left: 15px;
    margin-top: 10px;
    display: inline-block;
}
.productselectedfilter .clearfilter:hover{
   /*text-shadow: 0px 0px 1px #303030;*/
   font-weight:bold;
  text-decoration: underline;
}
.b-form-tags.form-control.h-auto.mb-2 {
    width: auto;
    font-size: 12px;
    color: #303030;
    font-weight: normal;
    background: #ececec;
    box-sizing: border-box;
    padding: 10px 10px;
    float: left;
    border-radius: 3px;
    margin-left: 15px;
    border: none;
}
.b-form-tags.form-control.h-auto.mb-2:first-child {
    margin-left: 0;
}
.b-form-tags.form-control.h-auto.mb-2{
	transition: all .2s ease;
}
.b-form-tags.form-control.h-auto.mb-2:hover{
	-webkit-transform: translate(0,-4px);
    -ms-transform: translate(0,-4px);
    transform: translate(0,-4px);
}
.card.mt-1.mr-1 {
    margin: 0;
    padding: 0;
    background: transparent;
    border: 0;
    float:left;
}
.card-body.py-1.pr-2.text-nowrap {
    padding: 0 !important;
    background: transparent;
    margin-right:7px;
}
.card-body.py-1.pr-2.text-nowrap strong{
    font-weight:normal;
}
/*.card-body.py-1.pr-2.text-nowrap strong:hover{
text-shadow: 0px 0px 1px #303030;
  text-decoration: underline;
}*/
button.btn.btn-link.btn-sm{
    padding: 0;
    margin: 0;
    line-height: normal;
}
button.btn.btn-link.btn-sm .closefilter{
    height: 8px;
    width: 8px;
}
.mainproducts .productbox{
    margin-bottom: 20px;
    margin-right: 20px;
    position: relative;
    overflow: hidden;
}
.mainproducts .productbox:nth-child(4n+4) {
    margin-right: 0;
}
.mainproducts .productbox .imgbox{
    height: 265px;
    max-width: 265px;
    width: 100%;
    position: relative;
    display: inline-block;
    border-radius: 3px;
    overflow: hidden;
}
.mainproducts .productbox .imgbox img.proimg{
    width: 100%;
    -webkit-transform: scale(1);
	transform: scale(1);
	-webkit-transition: .3s ease-in-out;
	transition: .3s ease-in-out;
}
.mainproducts .productbox .imgbox:hover img.proimg{
    -webkit-transform: scale(1.05);
	transform: scale(1.05);
}
.mainproducts .productbox .imgbox img.cw-overlay{
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    background: #000;
    padding: 2px;
    max-height: 25px;
}
.mainproducts .productbox .imgbox span.newtag,.mainproducts .productbox .imgbox span.saletag{
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    display: inline-block;
    background: #303030;
    color: #fff;
    font-weight: 600;
    font-size: 12px;
    line-height: 25px;
    padding: 0 8px;
}
.mainproducts .productbox .imgbox span.saletag{
    background: red;
}
.mainproducts .productbox .contentbox{
    width: 100%;
    max-width: 265px;
}
.mainproducts .productbox .contentbox .smallimages{
    width: 100%;
    display:flex;
    justify-content:flex-start;
    flex-wrap: nowrap;
    align-items: center;
    margin-bottom: 8px;
}
.mainproducts .productbox .contentbox .smallimages .forborder{
    padding: 2px;
    border: 1px solid #fff;
    display: inline-block;
    width: auto;
    position: relative;
    margin-right: 4px;
    border-radius: 3px;
    text-decoration: none;
}
.mainproducts .productbox .contentbox .smallimages .forborder:hover,.mainproducts .productbox .contentbox .smallimages .forborder.selected{
    border:1px solid #303030;
    text-decoration: none;
}
.mainproducts .productbox .contentbox .smallimages img.smallimg{
    height: 35px;
    width: 35px;
    border-radius: 3px;
}
.mainproducts .productbox .contentbox .smallimages .moreprod{
    background: #ececec;
    height: 35px;
    width: 35px;
    font-size: 12px;
    color: #303030;
    font-weight: 600;
    text-align: center;
    line-height: 35px;
    border-radius: 3px;
    text-decoration: none;
}
.mainproducts .productbox .contentbox h4{
    text-align: left;
    margin-bottom: 3px;
}
.mainproducts .productbox .contentbox h4 a{
    color:#303030;
    text-decoration: none;
    font-size: 14px;
    display: inline-block;
    width: 100%;
}
.mainproducts .productbox .contentbox p{
    font-size: 12px;
    line-height: 24px;
    color: #303030;
    text-align: left;
    width: 100%;
    font-weight: normal;
    float: left;
}
.mainproducts .productbox .contentbox p.regprice{
    width: auto;
}
.mainproducts .productbox .contentbox span.saleprice{
    color: red;
    font-size: 12px;
    font-weight: normal;
}
.productsbar .propagination{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 70px;
}
.productsbar .itemspage{
    width: 225px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    right: 0;
}
.productsbar .itemspage .pageitem{
   float: left;
   font-size: 14px;
   color: #303030;
   font-weight: normal;
   margin-top:3px;
}
.productsbar .propagination .custompage{
    margin-top: 0  !important;
}
.productsbar .propagination .custompage .pagination{
    align-items: center;
}
.productsbar .propagination .custompage .page-link{
    border:none;
    color: #777777!important;
    font-size: 14px;
    font-weight: normal;
    padding: 14px 17px 10px 17px;
}
.productsbar .propagination .custompage .page-item:first-child .page-link,.productsbar .propagination .custompage .page-item:last-child .page-link{
    color: #303030 !important;
    font-size: 28px;
    padding-top: 0;
    padding-bottom: 0;
}
.productsbar .propagination .custompage .page-item.active .page-link{
    background: transparent;
    font-weight: 600;
    color: #303030 !important;
}
.productsbar .propagination .custompage .page-item.disabled.bv-d-xs-down-none .page-link{
    font-size: 26px;
}
.productsbar .propagination .custompage .page-link:hover{
    background: transparent;
    color: #303030;
    font-weight: 600;
}
@media only screen and (max-width: 1440px){
    .filterbar{
        width: 18.5%;
    }
    .productsbar{
        width:78.5%;
    }
    .productsbar .mainproducts .productbox .imgbox{
        height: 235px;
        max-width: 235px;
    }
    .productsbar .mainproducts .productbox .contentbox{
        max-width: 228px;
    }
    .productsbar .mainproducts .productbox .contentbox .smallimages img.smallimg{
        height: 30px;
        width: 30px;
    }
    .productsbar .mainproducts .productbox .contentbox .smallimages .moreprod{
        height: 30px;
        width: 30px;
        line-height: 34px;
        font-size: 11px;
    }
    .mainproducts .productbox{
        margin-bottom:17px;
        margin-right:10px;
    }
}
@media only screen and (max-width: 1199px) and (min-width: 1025px) {
    .productsbar h1, .page--productstrim .productsbar h2, .page--productssample .productsbar h2{
        width:74%;
    }
    .productsbar .topsection .sortby{
        width: 26%;
    }
    .mainproducts .productbox{
        width:24%;
    }
    .productsbar .mainproducts .productbox .imgbox{
        height: auto;
        width: auto;
    }
    .productsbar .mainproducts .productbox .contentbox .smallimages img.smallimg {
        height: 20px;
        width: 20px;
    }
    .productsbar .mainproducts .productbox .contentbox .smallimages .moreprod{
        height: 20px;
        width: 20px;
        line-height: 24px;
        font-size: 9px;
    }
}
@media only screen and (max-width:1024px) and (min-width:768px){
	.productsbar .mainproducts .productbox .imgbox {
		height: 165px;
		max-width: 165px;
		width:165px;
	}
	.filterbar {
		width: 25.5%;
	}
	.filterbar .filter_by ul li a{
		height: 45px;
		line-height: 45px;
		font-size: 12px;
	}
	.filter_by .md-radio .md-radio-label{
		padding-left:10px;
		display: inline-block;
		height: auto;
	}
	.productsbar .mainproducts .productbox .contentbox {
		max-width: 165px;
	}
	.productsbar {
		width: 71.5%;
	}
	.productsbar h1,.page--productstrim .productsbar h2,.page--productssample .productsbar h2{
		width:56%;
	}
	.productsbar .topsection .sortby{
		width:44%;
	}
	.sortby .vs__dropdown-menu{
		left:-40px;
	}
	.mainproducts .productbox .contentbox .smallimages .forborder{
		margin-right:0;
	}
	.mainproducts .productbox .contentbox p.regprice,
	.mainproducts .productbox .contentbox span.saleprice{
		width:100%;
	}
	.productsbar .mainproducts .productbox .contentbox .smallimages img.smallimg{
		height:20px;
		width:20px;
	}
	.productsbar .mainproducts .productbox .contentbox .smallimages .moreprod {
		height: 20px;
		width: 20px;
		line-height: 23px;
		font-size: 10px;
	}
	.mainproducts{
		margin-bottom:20px;
	}
	.mainproducts .productbox:nth-child(4n+4) {
		margin-right: 10px;
	}
	.mainproducts .productbox:nth-child(3n+3) {
		margin-right: 0;
	}
	.productsbar .itemspage{
		display:none;
	}
}
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2){
	.mainproducts .productbox,.mainproducts .productbox:nth-child(4n+4) {
		margin-right:17px;
	}
	.productsbar .mainproducts .productbox .imgbox {
		height: 217px;
		max-width: 217px;
		width: 217px;
	}
}
@media only screen and (max-width:767px){
	.container, header .container {
		max-width: 100%;
		padding:0 20px;
		box-sizing:border-box;
	}
	.mainproduct_listing{
		flex-wrap:wrap;
	}
	.mobile-category {
		display: none;
	}
	.breadcrumb{
		margin-top:25px;
	}
	.filterbar{
		width:100%;
		max-width:100%;
		padding-bottom:0;
		padding-top: 20px;
	}
	.allfilter{
		display:none;
		margin-bottom:40px;
	}
	.filtershow{
		display:block;
	}
	.filtershow {
		display: block;
		color: #303030;
		font-size: 16px;
		float: left;
		margin: 0 0 10px 0;
		width: 100%;
	}
	.filtershow:hover{
		color:#303030;
		text-decoration:none !important;
	}
	.filtershow .plusfil {
		width: 12px;
		margin-left: 5px;
		display: inline-block;
    }
    .filtershow .minusfil {
		width: 12px;
		margin-left: 5px;
		display: none;
    }
    .filtershow.minusshow .plusfil{
        display: none;
    }
    .filtershow.minusshow .minusfil{
        display: inline-block;
    }
	.productsbar {
		width: 100%;
	}
	.productsbar h1,.page--productstrim .productsbar h2,.page--productssample .productsbar h2{
		width:100%;
	}
	.productsbar .topsection h1,.productsbar .topsection h2{
		display:none;
	}
	h1.desktop-hide{
		display:block;
		margin-top:20px;
	}
	.productsbar .topsection .sortby{
		width: 70%;
		float: left;
		margin-top: 0;
	}
	.productsbar .topsection .sortby .sort{
		width:100px;
	}
	.mainproducts .productbox .contentbox p.regprice,
	.mainproducts .productbox .contentbox span.saleprice{
		width:100%;
	}
	.mainproducts{
		justify-content:space-between;
		margin-bottom:20px;
	}
	.productsbar .propagination{
		flex-wrap:wrap;
	}
	.productsbar .itemspage{
		position:relative;
		right:auto;
		display:none;
	}
	.mainproducts .productbox {
		margin-right: 0;
		width: 49%;
	}
	.productsbar .mainproducts .productbox .imgbox{
	    height: 180px;
		max-width: 182px;
	}
	.productsbar .mainproducts .productbox .imgbox img.proimg{
		height: 175px;
		-o-object-fit: cover;
		object-fit: cover;
	}
	.mainproducts .productbox .contentbox .smallimages .forborder{
		margin-right:0;
	}
	.productsbar .mainproducts .productbox .contentbox .smallimages img.smallimg{
		height: 25px;
		width: 25px;
	}
	.productsbar .mainproducts .productbox .contentbox .smallimages .moreprod{
		height: 25px;
		width: 25px;
		line-height: 28px;
		font-size: 10px;
	}
	.mainproducts .productbox .contentbox h4 a{
		font-size:13px;
	}
}
@media only screen and (max-width:375px){
    .productsbar .mainproducts .productbox .imgbox {
        height: 156px;
    }
    .productsbar .mainproducts .productbox .imgbox img.proimg{
        height:156px;
    }
	.productsbar .topsection .sortby{
		width:75%;
	}
}
</style>